import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LanguageResolverService } from './resolver/language-resolver.service';

const routes: Routes = [
  {
    path: 'introduction',
    loadChildren: () =>
      import('./introduction/introduction.module').then((m) => m.IntroductionPageModule),
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./onboarding/onboarding.module').then((m) => m.OnboardingPageModule),
  },
  {
    path: 'splash',
    loadChildren: () => import('./splash/splash.module').then((m) => m.SplashPageModule),
  },
  {
    path: 'not-found',
    loadChildren: () => import('./not-found/not-found.module').then((m) => m.NotFoundPageModule),
  },
  {
    path: ':lang',
    // resolve: {
    //   langParam: LanguageResolverService,
    // },
    loadChildren: () =>
      import('./language-inspector/language-inspector.module').then(
        (m) => m.LanguageInspectorModule,
      ),
  },
  {
    path: '',
    redirectTo: 'introduction',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
